import { setError } from '../App/ErrorsActions';

import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';
import { calculateCycleTimeDistribution } from '../../util/calcUtils';

export const ERROR = 'CTH_ERROR';
export const LOADING = 'CTH_LOADING';
export const LOADING_DETAILS = 'CTH_LOADING_DETAILS';
export const SUCCESS = 'CTH_SUCCESS';
export const SUCCESS_DETAILS = 'CTH_SUCCESS_DETAILS';

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

function detailsIsLoading(bool) {
  return {
    type: LOADING_DETAILS,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data
  };
}

export function successDetails(data, isFatTailed) {
  return { type: SUCCESS_DETAILS, isFatTailed, data };
}

export function getData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const {
      chart,
      allCustomFields,
      excludeWeekends,
      workStart,
      workEnd,
      holidays,
      dates,
      enabledColors,
      cth
    } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : cth;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      let ctData = await worker.CycleTimeScatterPlot({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        blockedTime: filters.blockedTime,
        blockers: filters.blockers,
        customFields,
        excludeWeekendOpts: {
          type: excludeWeekends,
          workStart,
          workEnd,
          holidays
        },
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        color: true,
        useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
      });
      dispatch(success(ctData));

      const excludeWeekendOpts = {
        type: excludeWeekends,
        workStart,
        workEnd,
        holidays
      };
      let cthData = await worker.CycleTimeHistogram({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        blockedTime: filters.blockedTime,
        blockers: filters.blockers,
        customFields,
        excludeWeekendOpts,
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: cth.timeUnit,
        percentiles: allFilters.allPercentileValues,
        useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
      });
      const isFatTailed = calculateCycleTimeDistribution(cthData, excludeWeekendOpts, user.config && user.config.useWorkingHoursInCycleTimeDays);
      dispatch(successDetails(cthData, isFatTailed));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}

export function getDetailsData(dates) {
  return async (dispatch, getState) => {
    dispatch(detailsIsLoading(true));

    const { user } = getState().auth;
    const { selected } = getState().dashboards;
    const { data } = getState().app;

    const allFilters = getState().filters;
    const { chart, allCustomFields, excludeWeekends, workStart, workEnd, holidays, enabledColors, cth } = allFilters;
    const filters = chart === 'overview' ? allFilters.overview : cth;

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    const excludeWeekendOpts = {
      type: excludeWeekends,
      workStart,
      workEnd,
      holidays
    };

    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      isCsv: selected.isCsv,
      enableDoneFilters: user.config.enableDoneFilters,
      enableMissingDoneActivitiesInserting: user.config.enableMissingDoneActivitiesInserting
    });
    try {
      let cthData = await worker.CycleTimeHistogram({
        lists: filters.selectedLists,
        labels: filters.selectedLabels,
        members: filters.selectedMembers,
        customFields,
        blockedTime: filters.blockedTime,
        blockers: filters.blockers,
        excludeWeekendOpts,
        from: dates.startDate.toISOString(),
        to: dates.endDate.toISOString(),
        timeUnit: cth.timeUnit,
        percentiles: allFilters.allPercentileValues,
        useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
      });
      const isFatTailed = calculateCycleTimeDistribution(cthData, excludeWeekendOpts, user.config && user.config.useWorkingHoursInCycleTimeDays);
      dispatch(successDetails(cthData, isFatTailed));
    } catch (err) {
      dispatch(setError(err));
    }
  };
}
